import { Typography } from '@material-ui/core';
import { Trans } from 'react-i18next';
import React from 'react';
import { Link } from 'react-router-dom';

function TermsOfUse(props) {
  const { to } = props;
  return (
    <Typography variant="body2" align="left">
      <Trans i18nKey="registrationForm.footer.termsOfUse">
        %<Link to={to} />%
      </Trans>
    </Typography>
  );
}

export default TermsOfUse;
